import { selectWidgets } from "views/logic/slices/viewSelectors";
import MessagesWidget from "views/logic/widgets/MessagesWidget";
import { updateWidgets } from "views/logic/slices/widgetActions";
const RemoveFromAllTablesActionHandler = ({ field }) => (dispatch, getState) => {
  const widgets = selectWidgets(getState());
  const newWidgets = widgets.map((widget) => {
    if (widget.type.toUpperCase() === MessagesWidget.type.toUpperCase()) {
      const newFields = widget.config.fields.filter((f) => f !== field);
      const newConfig = widget.config.toBuilder().fields(newFields).build();
      return widget.toBuilder().config(newConfig).build();
    }
    return widget;
  }).toList();
  return dispatch(updateWidgets(newWidgets));
};
export default RemoveFromAllTablesActionHandler;
